import { h } from 'preact';
import Store from 'store/store';
import * as oneTrust from 'utils/gdpr/oneTrust';

const dropCookie = new oneTrust.Pixel(
	oneTrust.FUNCTIONAL,
	(expiryDate) => {
		document.cookie = `signupBannerSeen=true; expires=${expiryDate.toUTCString()}`;
	},
	true
).createTrigger();

Store.on('DROP_SIGNUP_COOKIE', (expiryDate) => {
	dropCookie(expiryDate);
});
